/**
 * MINICELL DETAILS RTE 공백/제로폭 문자 런타임 정리
 * - NBSP/제로폭 문자 → 정상화
 * - 블록 시작부 선행 공백 제거
 * - 공백만 있는 <p> 제거
 * - 아코디언/섹션 리렌더에도 자동 재실행
 */
(function () {
  // 문제 문자 정의
  const NBSPS = /[\u00A0\u202F\u2007\u2060\uFEFF]/g; // NBSP 계열 → ' ' 로
  const ZWSP  = /[\u200B]/g;                         // 제로폭 → 제거

  // 특정 RTE 루트 정리
  function cleanRte(root) {
    if (!root) return;
    // 텍스트 노드 정규화 + 블록 시작 선행 공백 제거
    root.querySelectorAll('*').forEach(el => {
      el.childNodes.forEach(n => {
        if (n.nodeType === 3) {
          n.nodeValue = n.nodeValue
            .replace(NBSPS, ' ')
            .replace(ZWSP, '')
            .replace(/\s+/g, ' ')
            .replace(/^\s+/, ''); // 줄 시작 공백 제거
        }
      });
    });
    // Apple-converted-space 제거
    root.querySelectorAll('span.Apple-converted-space').forEach(s =>
      s.replaceWith(document.createTextNode(' '))
    );
    // 공백만 담긴 <p> 제거
    root.querySelectorAll('p').forEach(p => {
      if (!p.textContent.replace(/\s/g, '').length) p.remove();
    });
  }

  // “Details” 아코디언 내부 RTE들을 수집
  function findDetailRtes() {
    // summary가 "Details"인 <details>만 골라 안전하게 범위 한정
    const detailsBlocks = Array.from(document.querySelectorAll('details'))
      .filter(d => /details/i.test((d.querySelector('summary')?.textContent || '').trim()));
    const roots = detailsBlocks
      .map(d => d.querySelector('.details-content .rte'))
      .filter(Boolean);
    // 중복 제거
    return Array.from(new Set(roots));
  }

  // 한 번 실행
  function run() {
    findDetailRtes().forEach(cleanRte);
  }

  // DOM 준비 → 실행 + 이후 변화 감시(하이드레이션/아코디언 열림/섹션 리렌더)
  function start() {
    run();
    // 변경사항이 생기면 다시 정리 (가볍게 전체 문서 관찰)
    const mo = new MutationObserver(muts => {
      if (muts.some(m => m.addedNodes && m.addedNodes.length)) {
        // 너무 자주 돌지 않도록 소량 지연
        clearTimeout(start._t);
        start._t = setTimeout(run, 60);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
